<div class="aca-auth">
  <!-- language, top right — the only control on this screen that works before
       anyone signs in, and the one that decides the language of everything else -->
  <label class="aca-auth__lang">
    <mat-icon>language</mat-icon>
    <select [ngModel]="language" (ngModelChange)="changeLanguage($event)" [attr.aria-label]="'DMS.APP_LOGIN.485E68' | translate">
      <option *ngFor="let option of languages" [value]="option.key">{{ option.label | translate }}</option>
    </select>
  </label>

  <!-- ── brand panel ─────────────────────────────────────────────────────── -->
  <aside class="aca-auth__brand">
    <span class="aca-auth__dots" aria-hidden="true"></span>

    <!-- the shipped brand asset, cropped to its mark: the wordmark beside it is
         navy and would not read on this panel, so the name is set in white -->
    <div class="aca-auth__logo">
      <span class="aca-auth__logomark" [class.aca-auth__logomark--custom]="branding.customLogo()">
        <img [src]="branding.logo()" alt="" aria-hidden="true" />
      </span>
      <span class="aca-auth__logoname">{{ branding.name() }}</span>
    </div>

    <div class="aca-auth__welcome">
      <h1>{{ 'DMS.APP_LOGIN.134E57' | translate }}</h1>
      <p class="aca-auth__welcomesub">{{ 'DMS.APP_LOGIN.2B6243' | translate }}</p>
      <p class="aca-auth__welcometext">{{ 'DMS.APP_LOGIN.2DCC1C' | translate }}<br />{{ 'DMS.APP_LOGIN.15A8FE' | translate }}</p>
    </div>

    <!-- the reference artwork itself, cropped from the supplied panel. Its blue
         ground is part of the image, which is why the panel's own gradient is
         sampled from that same file — see the note in the stylesheet. -->
    <div class="aca-auth__art">
      <img src="./assets/images/login-illustration.png" alt="" aria-hidden="true" />
    </div>

    <ul class="aca-auth__features">
      <li>
        <span class="aca-auth__featureicon"><mat-icon>verified_user</mat-icon></span>
        <strong>{{ 'DMS.APP_LOGIN.1040A8' | translate }}</strong>
        <span>{{ 'DMS.APP_LOGIN.AB57A6' | translate }}</span>
      </li>
      <li>
        <span class="aca-auth__featureicon"><mat-icon>folder_open</mat-icon></span>
        <strong>{{ 'DMS.APP_LOGIN.493EDE' | translate }}</strong>
        <span>{{ 'DMS.APP_LOGIN.B417B2' | translate }}</span>
      </li>
      <li>
        <span class="aca-auth__featureicon"><mat-icon>group</mat-icon></span>
        <strong>{{ 'DMS.APP_LOGIN.C5A778' | translate }}</strong>
        <span>{{ 'DMS.APP_LOGIN.F97D74' | translate }}</span>
      </li>
      <li>
        <span class="aca-auth__featureicon"><mat-icon>history</mat-icon></span>
        <strong>{{ 'DMS.APP_LOGIN.9D0E65' | translate }}</strong>
        <span>{{ 'DMS.APP_LOGIN.9FEF9D' | translate }}</span>
      </li>
    </ul>

    <footer class="aca-auth__brandfoot">
      <span>© {{ year }} Alfresco. {{ 'DMS.UI.C78899' | translate }}</span>
      <!-- plain text, not links: this application ships no privacy or terms page,
           and a link that goes nowhere is worse than a line that does not claim to -->
      <span class="aca-auth__brandlinks">
        <span>{{ 'DMS.APP_LOGIN.3FE89A' | translate }}</span>
        <i aria-hidden="true">|</i>
        <span>{{ 'DMS.APP_LOGIN.362916' | translate }}</span>
      </span>
    </footer>
  </aside>

  <!-- ── sign-in card ───────────────────────────────────────────────────── -->
  <main class="aca-auth__card">
    <h2 class="aca-auth__cardtitle">{{ 'DMS.APP_LOGIN.25BF4E' | translate }}</h2>
    <p class="aca-auth__cardsub">{{ 'DMS.APP_LOGIN.D5ADFD' | translate }}</p>

    <adf-login
      class="aca-auth__login"
      successRoute="/dashboard"
      (success)="onSignedIn()"
      [showRememberMe]="true"
      [showLoginActions]="false"
      [copyrightText]="''"
    >
      <adf-login-footer>
        <ng-template>
          <button type="button" class="aca-auth__forgot" (click)="showResetHelp = !showResetHelp">{{ 'DMS.APP_LOGIN.9D6A08' | translate }}</button>
        </ng-template>
      </adf-login-footer>
    </adf-login>

    <p class="aca-auth__note" *ngIf="showResetHelp">{{ 'DMS.APP_LOGIN.58EB92' | translate }}</p>

    <!-- single sign-on only where an identity provider is configured: buttons
         that cannot work are noise on the one screen everyone sees -->
    <div class="aca-auth__sep" *ngIf="ssoConfigured">
      <span>{{ 'DMS.APP_LOGIN.A0857B' | translate }}</span>
    </div>

    <div class="aca-auth__sso" *ngIf="ssoConfigured">
      <button type="button" class="aca-auth__ssobtn" [disabled]="!ssoConfigured">
        <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
          <path fill="#F25022" d="M1 1h10v10H1z" />
          <path fill="#7FBA00" d="M13 1h10v10H13z" />
          <path fill="#00A4EF" d="M1 13h10v10H1z" />
          <path fill="#FFB900" d="M13 13h10v10H13z" />
        </svg>
        Microsoft 365
      </button>
      <button type="button" class="aca-auth__ssobtn" [disabled]="!ssoConfigured">
        <svg viewBox="0 0 48 48" width="18" height="18" aria-hidden="true">
          <path
            fill="#EA4335"
            d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"
          />
          <path
            fill="#4285F4"
            d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"
          />
          <path
            fill="#FBBC05"
            d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"
          />
          <path
            fill="#34A853"
            d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"
          />
        </svg>
        Google Workspace
      </button>
    </div>

    <p class="aca-auth__help">{{ 'DMS.APP_LOGIN.833BDC' | translate }}</p>
  </main>
</div>
